import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box,
    Modal,
    Button,
    CircularProgress,
    Tooltip
} from '@mui/material';
import { Icon } from "@iconify/react";
import Select from "react-select";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/store.css";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import { AsyncPaginate } from "react-select-async-paginate";
import TVFMLoader from "../Loader/loader.jsx";
import Footer from "../Footer/Footer-page.jsx";
const FranchisePage = () => {
    const EMPTY_ARRAY = [];
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const isAddFranchise = location.pathname === '/franchisor/add';
    const [searchQuery, setSearchQuery] = useState('');
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'FranchisorName',
        'FranchisorAdmin',
        'Email',
        'Phone Number',
        'Action',
    ];
    const [franchises, setFranchises] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [franchisesToDelete, setFranchisesToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editFranchiseId, setEditFranchiseId] = useState(null);
    const [selectedUser, setSelectedUser] = useState([]);
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [brands, setBrands] = useState([{ name: "" }]);
    const [isViewFranchise, setIsViewFranchise] = useState(false);
    const [viewFranchiseData, setViewFranchiseData] = useState(null);
    const [showGstPan, setShowGstPan] = useState(false);

    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const [loading, setLoading] = useState({});
    const [storeOptions, setStoreOptions] = useState([]);
    const [selectedStores, setSelectedStores] = useState(initialStoreId);
    const [documents, setDocuments] = useState([
        { documentType: "", documentName: "", files: [] }
    ]);
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState("");



    const handleBrandChange = (index, value) => {
        const updated = [...brands];
        updated[index].name = value;
        setBrands(updated);

        // Update formData brandNames array
        setFormData(prev => ({
            ...prev,
            brandNames: updated.map(b => b.name).filter(Boolean)
        }));
    };

    const addBrandRow = () => {
        setBrands(prev => [...prev, { name: "" }]);
    };

    const removeBrandRow = (index) => {
        const updated = brands.filter((_, i) => i !== index);
        setBrands(updated);

        setFormData(prev => ({
            ...prev,
            brandNames: updated.map(b => b.name).filter(Boolean)
        }));
    };



    const [formData, setFormData] = useState({
        franchiseName: '',
        emailAddress: '',
        phoneNumber: '',
        address: '',
        postalCode: '',
        state: '',
        country: '',
        description: '',
        franchiseAdmin: [],      // Single select user
        stores: [],              // Multi select stores
        brandNames: [],
        gstData: {
            gstNumber: '',
            valid: false,
            status: 'PENDING'
        },

        panData: {
            pan: '',
            type: '',
            valid: false,
            nameOnCard: '',
            status: 'PENDING'
        },

        documents: [],
        isActive: true
    });

    const addDocumentRow = () => {
        if (documents.length >= 10) {
            alert("You can upload a maximum of 10 document entries.");
            return;
        }
        setDocuments(prev => [
            ...prev,
            { documentType: "", documentName: "", files: [] }
        ]);
    };

    const removeDocumentRow = (index) => {
        setDocuments(prev => prev.filter((_, i) => i !== index));
    };

    const updateDocumentRow = (index, field, value) => {
        const updated = [...documents];
        updated[index][field] = value;
        setDocuments(updated);
    };

    const handleDocumentFiles = (index, fileList) => {
        const files = Array.from(fileList);
        const validFiles = files.filter(f => f.size <= 5 * 1024 * 1024);
        const invalidFiles = files.filter(f => f.size > 5 * 1024 * 1024);

        if (invalidFiles.length > 0) {
            alert("Some files exceed 5 MB limit. They were ignored.");
        }

        const updated = [...documents];
        updated[index].files = validFiles;
        setDocuments(updated);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const handleOpen = (storeId) => {
        setFranchisesToDelete(storeId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFranchisesToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAddFranchise = async (e) => {
        e.preventDefault();
        if (!validateFranchiseForm()) return;

        setShowLoader(true);
        try {
            const token = localStorage.getItem("Token");

            const franchiseData = {
                franchiseName: formData.franchiseName,
                emailAddress: formData.emailAddress,
                phoneNumber: formData.phoneNumber,
                address: formData.address,
                postalCode: formData.postalCode,
                state: formData.state,
                country: formData.country,
                description: formData.description,
                brandNames: formData.brandNames || [],
                franchiseAdmin: formData.franchiseAdmin,
                stores: formData.stores || [],

                gstData: {
                    gstNumber: formData.gstData.gstNumber,
                    valid: formData.gstData.valid,
                    status: formData.gstData.status
                },

                panData: {
                    pan: formData.panData.pan,
                    type: formData.panData.type,
                    valid: formData.panData.valid,
                    nameOnCard: formData.panData.nameOnCard,
                    status: formData.panData.status
                },

                documents: [],
                isActive: formData.isActive
            };

            // --------------------------
            //  DOCUMENT UPLOAD LOGIC
            // --------------------------
            for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                if (!doc.files || doc.files.length === 0) continue;

                let uploadedFiles = [];

                for (let file of doc.files) {
                    const uploadRes = await uploadFile("files/upload/franchise-docs", file);
                    if (uploadRes?.status === 200) {
                        uploadedFiles.push(uploadRes.data);
                    } else {
                        toast.error(`Failed to upload ${file.name}`);
                    }
                }

                franchiseData.documents.push({
                    documentType: doc.documentType,
                    documentName: doc.documentType === "OTHERS" ? doc.documentName : "",
                    files: uploadedFiles
                });
            }

            console.log("Sending franchise data:", franchiseData);

            const response = await postData("franchise/", franchiseData, token);

            toast.success(response.message || "Franchise added successfully");

            // ✅ RESET FORM
            setFormData({
                franchiseName: "",
                emailAddress: "",
                phoneNumber: "",
                address: "",
                postalCode: "",
                state: "",
                country: "",
                description: "",
                franchiseAdmin: "",
                brandNames: "",
                stores: [],

                gstData: {
                    gstNumber: "",
                    valid: false,
                    status: "PENDING"
                },

                panData: {
                    pan: "",
                    type: "",
                    valid: false,
                    nameOnCard: "",
                    status: "PENDING"
                },

                documents: [],
                isActive: true
            });

            setDocuments([{ documentType: "", documentName: "", files: [] }]);

            triggerRefresh();
            navigate("/franchisor");

        } catch (error) {
            console.error("Add Franchisor Error:", error);
            toast.error(error.message || "Add Franchisor Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };

    const handleDeleteFranchise = async () => {
        try {
            const token = localStorage.getItem("Token");

            const response = await deleteData(
                `franchise/franchise/${franchisesToDelete}`,
                token
            );

            toast.success(response.message || "Franchise deleted successfully");

            setFranchisesToDelete(null);
            fetchFranchises(currentPage, limit);
            handleClose();
            triggerRefresh();

        } catch (error) {
            console.error("Delete Franchise Error:", error);
            toast.error(error.message || "Delete Franchise Failed");
        }
    };

    const handleUpdateFranchise = async (e) => {
        e.preventDefault();

        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            const updateData = {
                franchiseName: formData.franchiseName,
                emailAddress: formData.emailAddress,
                phoneNumber: formData.phoneNumber,
                address: formData.address,
                brandNames: formData.brandNames,
                postalCode: formData.postalCode,
                state: formData.state,
                country: formData.country,
                description: formData.description,
                franchiseAdmin: formData.franchiseAdmin,
                stores: formData.stores,
                gstData: formData.gstData || null,
                panData: formData.panData || null,
                documents: [],
                isActive: formData.isActive
            };

            // --------------------------
            // DOCUMENT UPDATE LOGIC
            // --------------------------
            for (let doc of documents) {
                let finalFiles = doc.files?.filter((f) => f.uri) || [];

                if (doc.newFiles?.length) {
                    for (let file of doc.newFiles) {
                        const uploadRes = await uploadFile("files/upload/franchise-docs", file);
                        if (uploadRes?.status === 200) {
                            finalFiles.push(uploadRes.data);
                        }
                    }
                }

                updateData.documents.push({
                    documentType: doc.documentType,
                    documentName: doc.documentType === "OTHERS" ? doc.documentName : "",
                    files: finalFiles
                });
            }

            console.log("UPDATE PAYLOAD →", updateData);

            const response = await putData(
                `franchise/franchise/${editFranchiseId}`,
                updateData,
                token
            );

            toast.success(response.message || "Franchise updated successfully");

            fetchFranchises();
            setIsPopupMode(false);
            triggerRefresh();

        } catch (error) {
            console.error("Update Franchise Error:", error);
            toast.error(error.message || "Failed to update franchise");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };



    useEffect(() => {
        const token = localStorage.getItem("Token");
        fetchFranchises(currentPage, limit, searchQuery, token);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchFranchises = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            franchiseName: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };

        try {
            setLoading(true);
            const response = await getData('franchise/franchises', params, sessionToken);
            console.log("📊 LIST RESPONSE:", response);

            // Robust extraction for List
            let franchiseList = [];
            let totalCount = 0;
            let totalPages = 1;

            if (response?.results) {
                // Case: { results: [], totalItems: X, totalPages: Y }
                franchiseList = response.results;
                totalCount = response.totalItems || response.totalCount || response.results.length;
                totalPages = response.totalPages || 1;
            } else if (response?.data?.results) {
                // Case: { data: { results: [], totalItems: X } }
                franchiseList = response.data.results;
                totalCount = response.data.totalItems || response.data.totalCount || response.data.results.length;
                totalPages = response.data.totalPages || 1;
            } else if (Array.isArray(response?.data)) {
                // Case: { data: [] }
                franchiseList = response.data;
                totalCount = response.totalItems || response.totalCount || response.data.length;
                totalPages = response.totalPages || 1;
            }

            setFranchises(franchiseList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);

        } catch (error) {
            console.error("Failed to load franchises", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewFranchise = async (franchiseId) => {
        // 1️⃣ Reset and open modal immediately for better UX
        console.log("🔍 Fetching details for:", franchiseId);
        setViewFranchiseData(null);
        setIsViewFranchise(true);

        try {
            // 2️⃣ Fetch data quietly (local loader exists in modal)
            const res = await getData(`franchise/franchise/${franchiseId}`, {}, sessionToken);
            console.log("📬 API RAW RESPONSE (Full):", JSON.stringify(res, null, 2));

            // 3️⃣ Robust data extraction based on various possible wrappers
            let extractedData = null;

            // Check top-level results (User's pattern)
            if (res?.results && Array.isArray(res.results)) {
                extractedData = res.results[0];
            }
            // Check res.data.results
            else if (res?.data?.results && Array.isArray(res.data.results)) {
                extractedData = res.data.results[0];
            }
            // Check res.data
            else if (res?.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
                extractedData = res.data;
            }
            // Fallback: check if res is the object itself (look for unique keys)
            else if (res && res.franchiseName) {
                extractedData = res;
            }

            if (extractedData) {
                console.log("✅ SUCCESSFULLY EXTRACTED DATA:", extractedData);
                setViewFranchiseData(extractedData);
            } else {
                console.warn("⚠️ DATA EXTRACTION FAILED. res is:", res);
                // If it's a successful but empty response, maybe show "No data" instead of infinite loading
                setViewFranchiseData({}); // Set to empty object to stop loader and show empty state
                toast.warning("Franchise data not found");
            }
        } catch (error) {
            console.error("❌ ERROR FETCHING FRANCHISE:", error);
            toast.error("Failed to load details");
            setIsViewFranchise(false);
        }
    };

    const maskId = (value) => {
        if (!value || typeof value !== 'string' || value.length < 4) return value;
        return "XXXX-XXXX-" + value.slice(-2);
    };

    const decryptData = (encryptedData) => {
        try {
            if (!encryptedData || typeof encryptedData !== 'string') return encryptedData;
            if (encryptedData.includes(':')) {
                const parts = encryptedData.split(':');
                if (parts.length !== 2) return encryptedData;
                const iv = CryptoJS.enc.Hex.parse(parts[0]);
                const encrypted = CryptoJS.enc.Hex.parse(parts[1]);
                const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
                const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
                return decrypted.toString(CryptoJS.enc.Utf8) || encryptedData;
            }
            const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
            const bytes = CryptoJS.AES.decrypt(encryptedData, key);
            return bytes.toString(CryptoJS.enc.Utf8) || encryptedData;
        } catch (error) {
            return encryptedData;
        }
    };

    const validateFranchiseForm = () => {
        let newErrors = {};
        let valid = true;

        // ⭐ REQUIRED BASIC FIELDS
        if (!formData.franchiseName?.trim()) {
            newErrors.franchiseName = "Franchise Name is required";
            valid = false;
        }

        if (!formData.emailAddress?.trim()) {
            newErrors.emailAddress = "Email Address is required";
            valid = false;
        }

        if (!formData.phoneNumber || formData.phoneNumber.length !== 10) {
            newErrors.phoneNumber = "Phone Number must be 10 digits";
            valid = false;
        }

        // ----------------------------------------------------------------
        // ⭐ GST DATA VALIDATION (OPTIONAL)
        // ----------------------------------------------------------------
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (formData.gstData?.gstNumber?.trim()) {
            if (!gstRegex.test(formData.gstData.gstNumber)) {
                newErrors.gstData = { ...newErrors.gstData, gstNumber: "Invalid GST Number format" };
                valid = false;
            }
        }

        // ----------------------------------------------------------------
        // ⭐ PAN DATA VALIDATION (OPTIONAL)
        // ----------------------------------------------------------------
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (formData.panData?.pan?.trim()) {
            if (!panRegex.test(formData.panData.pan)) {
                newErrors.panData = { ...newErrors.panData, pan: "Invalid PAN format" };
                valid = false;
            }
        }

        // ----------------------------------------------------------------
        // ⭐ DOCUMENT VALIDATION (OPTIONAL)
        // ----------------------------------------------------------------
        documents.forEach((doc, index) => {
            const hasType = !!doc.documentType;
            const hasName = !!doc.documentName?.trim();
            const hasFiles = doc.files && doc.files.length > 0;

            if (hasType || hasName || hasFiles) {
                if (!doc.documentType) {
                    newErrors[`documentType_${index}`] = "Document Type is required";
                    valid = false;
                }

                if (doc.documentType === "OTHERS" && !doc.documentName?.trim()) {
                    newErrors[`documentName_${index}`] = "Document Name is required";
                    valid = false;
                }

                if (!doc.files || doc.files.length === 0) {
                    newErrors[`files_${index}`] = "At least one file is required";
                    valid = false;
                }
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 10,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadUsers = async (search, loadedOptions, { page }) => {
        try {
            const sessionToken = localStorage.getItem("Token");

            const data = await getData(
                "users/users",
                {
                    page,
                    limit: 10,
                    search,
                    role: "FranchiseAdmin",   // ⭐ ONLY FranchiseAdmin users
                    isFranchiseAssigned: false // ❌ HIDE ALREADY ASSIGNED ADMINS
                },
                sessionToken
            );

            const results = data?.data?.[0]?.paginatedResults || [];
            const hasMore = results.length > 0;

            const options = results.map((user) => ({
                value: user._id,
                label: user.userName || user.name || "Unnamed User",
            }));

            return {
                options,
                hasMore,
                additional: { page: page + 1 },
            };

        } catch (error) {
            console.error("Failed to load users", error);
            return {
                options: [],
                hasMore: false,
                additional: { page },
            };
        }
    };

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra & Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];

    const handleAddStoreClick = () => {
        navigate("/stores/add");
    };


    return (
        <div className="store-layout">
            <div className="store-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>

                    </div>
                )}
                <main className="store-main">
                    {isAddFranchise ? (
                        <div className="add-Store-form">
                            <Typography variant="h6" mb={2}>Add Franchisor</Typography>
                            <form className="Store-form" onSubmit={handleAddFranchise}>
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <div className="Store-form-row">
                                            {/* Franchise Name */}
                                            <div className="Store-form-group">
                                                <label htmlFor="franchiseName" className="input-label">
                                                    Franchisor Name <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Franchisor Name"
                                                    className="store-input"
                                                    value={formData.franchiseName || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, franchiseName: e.target.value }))
                                                    }
                                                />
                                                {errors.franchiseName && (
                                                    <p className="field-error">{errors.franchiseName}</p>
                                                )}
                                            </div>
                                            {/* Email Address */}
                                            <div className="Store-form-group">
                                                <label htmlFor="emailAddress" className="input-label">
                                                    Email Address <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    placeholder="Enter Email Address"
                                                    className="store-input"
                                                    value={formData.emailAddress || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, emailAddress: e.target.value }))
                                                    }
                                                />
                                                {errors.emailAddress && (
                                                    <p className="field-error">{errors.emailAddress}</p>
                                                )}
                                            </div>

                                            {/* Phone Number */}
                                            <div className="Store-form-group">
                                                <label htmlFor="phoneNumber" className="input-label">
                                                    Phone Number <span className="required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Phone Number"
                                                    className="store-input"
                                                    maxLength={10}
                                                    value={formData.phoneNumber || ""}
                                                    title="Mobile Number must be exactly 10 digits"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d{0,10}$/.test(value)) {
                                                            setFormData(prev => ({ ...prev, phoneNumber: value }));
                                                        }
                                                    }}
                                                />
                                                {errors.phoneNumber && (
                                                    <p className="field-error">{errors.phoneNumber}</p>
                                                )}
                                            </div>

                                            {/* Address */}
                                            <div className="Store-form-group">
                                                <label htmlFor="address" className="input-label">
                                                    Address
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Address"
                                                    className="store-input"
                                                    value={formData.address || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, address: e.target.value }))
                                                    }
                                                />
                                                {errors.address && (
                                                    <p className="field-error">{errors.address}</p>
                                                )}
                                            </div>

                                            {/* Postal Code */}
                                            <div className="Store-form-group">
                                                <label htmlFor="postalCode" className="input-label">
                                                    Postal Code
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Postal Code"
                                                    className="store-input"
                                                    value={formData.postalCode || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, postalCode: e.target.value }))
                                                    }
                                                />
                                                {errors.postalCode && (
                                                    <p className="field-error">{errors.postalCode}</p>
                                                )}
                                            </div>

                                            {/* State */}
                                            <div className="Store-form-group">
                                                <label htmlFor="state" className="input-label">
                                                    State
                                                </label>
                                                <Select
                                                    options={indianStates.map(s => ({ value: s, label: s }))}
                                                    value={formData.state ? { value: formData.state, label: formData.state } : null}
                                                    onChange={(opt) => setFormData(prev => ({ ...prev, state: opt?.value || "" }))}
                                                    placeholder="Select State"
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        control: (base) => ({
                                                            ...base,
                                                            borderRadius: '8px',
                                                            borderColor: '#e2e8f0',
                                                            minHeight: '42px',
                                                            boxShadow: 'none',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected ? '#3C0008' : state.isFocused ? '#f8e8ea' : 'white',
                                                            color: state.isSelected ? 'white' : '#2d2d2d',
                                                            cursor: 'pointer',
                                                        }),
                                                    }}
                                                />
                                                {errors.state && (
                                                    <p className="field-error">{errors.state}</p>
                                                )}
                                            </div>

                                            {/* Country */}
                                            <div className="Store-form-group">
                                                <label htmlFor="country" className="input-label">
                                                    Country
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Country"
                                                    className="store-input"
                                                    value={formData.country || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, country: e.target.value }))
                                                    }
                                                />
                                                {errors.country && (
                                                    <p className="field-error">{errors.country}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="Store-form-row">
                                            <div className="Store-form-group">
                                                <label className="input-label">Select Franchisor Admin</label>
                                                <AsyncPaginate
                                                    value={selectedUser}            // ✅ ARRAY
                                                    loadOptions={loadUsers}
                                                    isMulti                          // ✅ ENABLE MULTI SELECT
                                                    onChange={(users) => {
                                                        setSelectedUser(users);

                                                        // ✅ Store only IDs in formData
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            franchiseAdmin: users?.map(u => u.value) || [],
                                                        }));
                                                    }}
                                                    isClearable
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    placeholder="Search & Select Franchisor Admin(s)"
                                                    styles={{
                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />

                                            </div>
                                            <div className="Store-form-group">
                                                <label htmlFor="description" className="input-label">
                                                    Description
                                                </label>
                                                <textarea
                                                    placeholder="Enter Franchise Description"
                                                    className="store-input"
                                                    style={{ height: "80px" }}
                                                    value={formData.description || ""}
                                                    onChange={e =>
                                                        setFormData(prev => ({ ...prev, description: e.target.value }))
                                                    }
                                                />
                                                {errors.description && (
                                                    <p className="field-error">{errors.description}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="Store-form-row">
                                            <div className="Store-form-group" style={{ width: "100%" }}>
                                                <label className="input-label">Brand Names (Multiple)</label>

                                                <table className="brand-table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "60px" }}>#</th>
                                                            <th>Brand Name</th>
                                                            <th style={{ width: "100px" }}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {brands.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="store-input"
                                                                        placeholder="Enter Brand"
                                                                        value={item.name}
                                                                        onChange={(e) => handleBrandChange(index, e.target.value)}
                                                                        style={{ width: "95%" }}
                                                                    />
                                                                </td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => removeBrandRow(index)}
                                                                        disabled={brands.length === 1}
                                                                        className="remove-brand-btn"
                                                                    >
                                                                        ✕
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                <button
                                                    type="button"
                                                    onClick={addBrandRow}
                                                    className="add-brand-btn"
                                                >
                                                    + Add Brand Row
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    {/* GST Number */}
                                    <div className="Store-form-group">
                                        <label className="input-label">
                                            GST Number
                                        </label>
                                        <input
                                            type="text"
                                            className="store-input"
                                            value={formData.gstData?.gstNumber || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    gstData: {
                                                        ...prev.gstData,
                                                        gstNumber: e.target.value.toUpperCase(),
                                                    },
                                                }))
                                            }
                                        />
                                        {errors.gstData?.gstNumber && (
                                            <p className="fi    eld-error">{errors.gstData?.gstNumber}</p>
                                        )}
                                    </div>

                                    {/* GST Status */}
                                    <div className="Store-form-group">
                                        <label className="input-label">GST Status</label>
                                        <select
                                            className="store-input"
                                            value={formData.gstData?.status || "PENDING"}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    gstData: {
                                                        ...prev.gstData,
                                                        status: e.target.value,
                                                    },
                                                }))
                                            }
                                        >
                                            <option value="PENDING">PENDING</option>
                                            <option value="VERIFIED">VERIFIED</option>
                                            <option value="REJECTED">REJECTED</option>
                                        </select>
                                        {errors.gstData?.status && (
                                            <p className="field-error">{errors.gstData?.status}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="Store-form-section">
                                    <h3 className="section-title">PAN Details</h3>

                                    <div className="Store-form-row">

                                        {/* PAN Number */}
                                        <div className="Store-form-group">
                                            <label className="input-label">
                                                PAN
                                            </label>
                                            <input
                                                type="text"
                                                className="store-input"
                                                value={formData.panData?.pan || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        panData: { ...prev.panData, pan: e.target.value.toUpperCase() }
                                                    }))
                                                }
                                            />
                                            {errors.panData?.pan && (
                                                <p className="field-error">{errors.panData?.pan}</p>
                                            )}
                                        </div>

                                        {/* PAN Type */}
                                        <div className="Store-form-group">
                                            <label className="input-label">PAN Type</label>
                                            <select
                                                className="store-input"
                                                value={formData.panData?.type || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        panData: { ...prev.panData, type: e.target.value }
                                                    }))
                                                }
                                            >
                                                <option value="">Select Type</option>
                                                <option value="INDIVIDUAL">Individual</option>
                                                <option value="COMPANY">Company</option>
                                            </select>
                                            {errors.panData?.type && (
                                                <p className="field-error">{errors.panData?.type}</p>
                                            )}
                                        </div>
                                        <div className="Store-form-group">
                                            <label className="input-label">Name on Card</label>
                                            <input
                                                type="text"
                                                className="store-input"
                                                value={formData.panData?.nameOnCard || ""}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        panData: { ...prev.panData, nameOnCard: e.target.value }
                                                    }))
                                                }
                                            />
                                            {errors.panData?.nameOnCard && (
                                                <p className="field-error">{errors.panData?.nameOnCard}</p>
                                            )}
                                        </div>
                                        <div className="Store-form-group">
                                            <label className="input-label">Status</label>
                                            <select
                                                className="store-input"
                                                value={formData.panData?.status || "PENDING"}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        panData: { ...prev.panData, status: e.target.value }
                                                    }))
                                                }
                                            >
                                                <option value="VERIFIED">Verified</option>
                                                <option value="PENDING">Pending</option>
                                                <option value="REJECTED">Rejected</option>
                                            </select>
                                            {errors.panData?.status && (
                                                <p className="field-error">{errors.panData?.status}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    <div className="document-list">
                                        <label className="input-label">Franchise Documents</label>
                                        {documents.map((doc, index) => (
                                            <div key={index} className="document-row-single">

                                                {/* REMOVE BUTTON */}
                                                <button
                                                    type="button"
                                                    className="remove-doc-btn"
                                                    onClick={() => removeDocumentRow(index)}
                                                >
                                                    ✕
                                                </button>

                                                {/* DOCUMENT TYPE */}
                                                <select
                                                    className="store-input"
                                                    value={doc.documentType}
                                                    onChange={(e) =>
                                                        updateDocumentRow(index, "documentType", e.target.value)
                                                    }
                                                >
                                                    <option value="">Select Document Type</option>
                                                    <option value="MASKED UDYOG AADHAR">MASKED UDYOG AADHAR</option>
                                                    <option value="INCORPORATION CERTIFICATE">INCORPORATION CERTIFICATE</option>
                                                    <option value="MSME REGISTRATION">MSME REGISTRATION</option>
                                                </select>
                                                {errors[`documentType_${index}`] && (
                                                    <p className="field-error">{errors[`documentType_${index}`]}</p>
                                                )}

                                                {/* OTHERS free text input */}
                                                {doc.documentType === "OTHERS" && (
                                                    <>
                                                        <input
                                                            type="text"
                                                            className="store-input"
                                                            placeholder="Enter Document Name"
                                                            value={doc.documentName}
                                                            onChange={(e) =>
                                                                updateDocumentRow(index, "documentName", e.target.value)
                                                            }
                                                        />
                                                        {errors[`documentName_${index}`] && (
                                                            <p className="field-error">{errors[`documentName_${index}`]}</p>
                                                        )}
                                                    </>
                                                )}

                                                {/* File Upload */}
                                                <input
                                                    type="file"
                                                    multiple
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    className="store-input"
                                                    onChange={(e) => handleDocumentFiles(index, e.target.files)}
                                                />
                                                {errors[`files_${index}`] && (
                                                    <p className="field-error">{errors[`files_${index}`]}</p>
                                                )}

                                            </div>
                                        ))}

                                        {/* ADD NEW ROW BUTTON */}
                                        <button
                                            type="button"
                                            onClick={addDocumentRow}
                                            disabled={documents.length >= 10}
                                            className="add-row-btn"
                                        >
                                            + Add Document Row
                                        </button>
                                    </div>
                                </div>
                                <div className="Store-form-row">
                                    <div className="Store-form-group">
                                        <div className="Store-buttons">
                                            <button className="add-Product-button" type="submit">
                                                Add Franchisor
                                            </button>
                                            <button className="cancel-Product-button" onClick={() => navigate('/franchisor')}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <Typography variant="h6" mb={2}>Franchisors</Typography>
                            <div className="product-widgets">
                                <div className="product-widgets-header">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="product-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Icon icon='mdi:search' className="search-icon" />
                                    </div>
                                </div>
                                <button className="add-Product-button" onClick={() => navigate('/franchisor/add')}>+ Add Franchisor</button>
                            </div>
                            <Box component={Paper}>
                                <TableContainer sx={{
                                    overflow: 'auto',
                                    maxHeight: '400px',
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}>
                                    <Table className="custom-product-table"
                                        sx={{
                                            '& td, & th': {
                                                border: 'none',
                                            },
                                            border: 'none',
                                        }}>
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isFranchise = heading === "FranchiseName";
                                                    const isFranchiseAdmin = heading === "FranchiseAdmin";
                                                    const isEmail = heading === "Email";
                                                    const isPhoneNumber = heading === "Phone Number"
                                                    const sortKey = isFranchise
                                                        ? "franchiseName"
                                                        : isFranchiseAdmin
                                                            ? "franchiseAdmin"
                                                            : isEmail
                                                                ? "emailAddress"
                                                                : isPhoneNumber
                                                                    ? "phoneNumber"
                                                                    : null

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 1,
                                                                backgroundColor: '#3C0008',
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {franchises.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No Franchisors found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                franchises.map((franchise, index) => (
                                                    <TableRow key={franchise._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{franchise.franchiseName}</Typography></TableCell>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {franchise.franchiseAdmin?.[0]?.name
                                                                    ? franchise.franchiseAdmin[0].name
                                                                    : franchise.users?.find(u => u.role === "FranchiseAdmin")?.name || "N/A"}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{franchise.emailAddress}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{franchise.phoneNumber}</Typography></TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Franchise">
                                                                    <Icon
                                                                        icon={plusIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => handleViewFranchise(franchise._id)}
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Franchise">
                                                                    <Icon
                                                                        icon={editIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            // 1️⃣ UPDATE FORM DATA

                                                                            setFormData({
                                                                                franchiseName: franchise.franchiseName || "",
                                                                                emailAddress: franchise.emailAddress || "",
                                                                                phoneNumber: franchise.phoneNumber || "",
                                                                                address: franchise.address || "",
                                                                                postalCode: franchise.postalCode || "",
                                                                                state: franchise.state || "",
                                                                                country: franchise.country || "",
                                                                                description: franchise.description || "",
                                                                                brandNames: franchise.brandNames || [],
                                                                                franchiseAdmin: (franchise.franchiseAdmin || []).map(a => a._id),

                                                                                stores: franchise.stores?.map(s => s._id) || [],

                                                                                gstData: {
                                                                                    gstNumber: decryptData(franchise.gstData?.gstNumber) || "",
                                                                                    valid: franchise.gstData?.valid ?? false,
                                                                                    status: franchise.gstData?.status || "PENDING",
                                                                                },

                                                                                panData: {
                                                                                    pan: decryptData(franchise.panData?.pan) || "",
                                                                                    type: franchise.panData?.type || "",
                                                                                    valid: franchise.panData?.valid ?? false,
                                                                                    nameOnCard: franchise.panData?.nameOnCard || "",
                                                                                    status: franchise.panData?.status || "PENDING",
                                                                                },

                                                                                isActive: franchise.isActive ?? true,
                                                                            });

                                                                            // 2️⃣ STORE: Pre-Select Multi-Select Stores
                                                                            setSelectedStores(
                                                                                (franchise.stores || []).map((store) => ({
                                                                                    value: store._id,
                                                                                    label: store.storeName,
                                                                                }))
                                                                            );

                                                                            setSelectedUser(
                                                                                (franchise.franchiseAdmin || []).map(admin => ({
                                                                                    value: admin._id,
                                                                                    label: admin.name,
                                                                                }))
                                                                            );

                                                                            setBrands(
                                                                                (franchise.brandNames || []).length > 0
                                                                                    ? franchise.brandNames.map(b => ({ name: b }))
                                                                                    : [{ name: "" }]
                                                                            );

                                                                            // 4️⃣ DOCUMENTS
                                                                            setDocuments(
                                                                                franchise.documents?.map(d => ({
                                                                                    documentType: d.documentType,
                                                                                    documentName: d.documentName,
                                                                                    files: d.files
                                                                                })) || [{ documentType: "", documentName: "", files: [] }]
                                                                            );

                                                                            // 5️⃣ OPEN POPUP
                                                                            setEditFranchiseId(franchise._id);
                                                                            setIsPopupMode(true);
                                                                            setIsEditMode(true);
                                                                            setLoaderText("Updating Franchise...");
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title="Delete Franchise">
                                                                    {role !== "SelfAdmin" && (
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            onClick={() => handleOpen(franchise._id)}
                                                                        />
                                                                    )}
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="store-bottom">
                                    <div className="store-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="product-section showing-range">
                                        {`Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                                    </div>
                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        >
                                            <Icon icon="mdi:chevron-double-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        >
                                            <Icon icon="mdi:chevron-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        >
                                            <Icon icon="mdi:chevron-right" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        >
                                            <Icon icon="mdi:chevron-double-right" />
                                        </button>
                                    </div>
                                </div>
                            </Box>

                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    storeName: '',
                                                    branchName: '',
                                                    phoneNumber: '',
                                                    emailAddress: '',
                                                    address: '',
                                                    postalCode: '',
                                                    state: '',
                                                    country: '',
                                                    managerName: '',
                                                    managerEmail: '',
                                                    description: ''
                                                });
                                                setLoaderText("");
                                            }}
                                        />

                                        <div className="franchise-popup-form" style={{ padding: '25px' }}>
                                            <Typography variant="h6" textAlign="center" mb={4}>
                                                {isEditMode ? "Edit Franchisor" : "Add Franchisor"}
                                            </Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateFranchise}>
                                                {/* ROW 1: Franchise Name / Email / Phone */}
                                                <div className="form-group-row">
                                                    {/* Franchise Name */}
                                                    <div className="form-group">
                                                        <label className="input-label">Franchisor Name</label>
                                                        <input
                                                            type="text"
                                                            value={formData.franchiseName || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, franchiseName: e.target.value }))}
                                                        />
                                                    </div>

                                                    {/* Email Address */}
                                                    <div className="form-group">
                                                        <label className="input-label">Email Address</label>
                                                        <input
                                                            type="email"
                                                            value={formData.emailAddress || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, emailAddress: e.target.value }))}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="form-group-row">
                                                    {/* Phone Number */}
                                                    <div className="form-group">
                                                        <label className="input-label">Phone Number</label>
                                                        <input
                                                            type="text"
                                                            maxLength={10}
                                                            value={formData.phoneNumber || ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData(prev => ({ ...prev, phoneNumber: value }));
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {/* Address */}
                                                    <div className="form-group">
                                                        <label className="input-label">Address</label>
                                                        <input
                                                            type="text"
                                                            value={formData.address || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, address: e.target.value }))}
                                                        />
                                                    </div>
                                                </div>

                                                {/* ROW 2: Address / PostalCode / State */}
                                                <div className="form-group-row">
                                                    {/* Postal Code */}
                                                    <div className="form-group">
                                                        <label className="input-label">Postal Code</label>
                                                        <input
                                                            type="text"
                                                            value={formData.postalCode || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, postalCode: e.target.value }))}
                                                        />
                                                    </div>

                                                    {/* State */}
                                                    <div className="form-group">
                                                        <label className="input-label">State</label>
                                                        <Select
                                                            options={indianStates.map(s => ({ value: s, label: s }))}
                                                            value={formData.state ? { value: formData.state, label: formData.state } : null}
                                                            onChange={(opt) => setFormData(prev => ({ ...prev, state: opt?.value || "" }))}
                                                            placeholder="Select State"
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                control: (base) => ({
                                                                    ...base,
                                                                    borderRadius: '8px',
                                                                    borderColor: '#e2e8f0',
                                                                    minHeight: '42px',
                                                                    boxShadow: 'none',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isSelected ? '#3C0008' : state.isFocused ? '#f8e8ea' : 'white',
                                                                    color: state.isSelected ? 'white' : '#2d2d2d',
                                                                    cursor: 'pointer',
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* ROW 3: Country / Description */}
                                                <div className="form-group-row">

                                                    {/* Country */}
                                                    <div className="form-group">
                                                        <label className="input-label">Country</label>
                                                        <input
                                                            type="text"
                                                            value={formData.country || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, country: e.target.value }))}
                                                        />
                                                    </div>

                                                    {/* Description */}
                                                    <div className="form-group">
                                                        <label className="input-label">Description</label>
                                                        <textarea
                                                            style={{ height: "100px" }}
                                                            placeholder="Enter Description"
                                                            value={formData.description || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="form-group-row">
                                                    <div className="form-group" style={{ width: "100%" }}>
                                                        <label className="input-label">Brand Names (Multiple)</label>

                                                        <table className="brand-table">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: 50 }}>#</th>
                                                                    <th>Brand Name</th>
                                                                    <th style={{ width: 80 }}>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {brands.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="store-input"
                                                                                placeholder="Enter Brand"
                                                                                value={row.name}
                                                                                onChange={(e) => handleBrandChange(index, e.target.value)}
                                                                                style={{ width: "100%" }}
                                                                            />
                                                                        </td>
                                                                        <td style={{ textAlign: "center" }}>
                                                                            <button
                                                                                type="button"
                                                                                disabled={brands.length === 1}
                                                                                onClick={() => removeBrandRow(index)}
                                                                                style={{
                                                                                    background: "#dc3545",
                                                                                    color: "#fff",
                                                                                    border: "none",
                                                                                    borderRadius: 4,
                                                                                    padding: "6px 10px",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        <button
                                                            type="button"
                                                            onClick={addBrandRow}
                                                            style={{
                                                                marginTop: 10,
                                                                background: "#198754",
                                                                color: "#fff",
                                                                padding: "8px 12px",
                                                                borderRadius: 4,
                                                                cursor: "pointer",
                                                                border: "none"
                                                            }}
                                                        >
                                                            + Add Brand Row
                                                        </button>
                                                    </div>
                                                </div>


                                                {/* ROW 4: Franchisor Admin (Single Select) */}
                                                <div className="form-group-row">
                                                    <div className="form-group" style={{ width: "100%" }}>
                                                        <label className="input-label">
                                                            Franchisor Admin <span className="required">*</span>
                                                        </label>

                                                        <AsyncPaginate
                                                            value={selectedUser}      // <-- ARRAY of { value, label }
                                                            loadOptions={loadUsers}
                                                            isMulti                  // <-- REQUIRED (because franchiseAdmin is an ARRAY)
                                                            onChange={(users) => {
                                                                setSelectedUser(users);

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    franchiseAdmin: users?.map(u => u.value) || [],  // <-- ALWAYS ARRAY
                                                                }));
                                                            }}
                                                            isClearable
                                                            additional={{ page: 1 }}
                                                            placeholder="Search & Select Franchisor Admin(s)"
                                                            styles={{
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                        />

                                                    </div>
                                                </div>
                                                {/* ROW 6: GST SECTION */}
                                                <div className="form-section">
                                                    <h3 className="section-title">GST Details</h3>

                                                    <div className="form-group-row">
                                                        {/* GST Number */}
                                                        <div className="form-group">
                                                            <label className="input-label">GST Number</label>
                                                            <div style={{ position: 'relative' }}>
                                                                <input
                                                                    type="text"
                                                                    style={{ paddingRight: '40px' }}
                                                                    value={showGstPan ? (formData.gstData?.gstNumber || "") : maskId(formData.gstData?.gstNumber || "")}
                                                                    onChange={(e) =>
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            gstData: { ...prev.gstData, gstNumber: e.target.value }
                                                                        }))
                                                                    }
                                                                />
                                                                <Icon
                                                                    icon={showGstPan ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                                                    onClick={() => setShowGstPan(!showGstPan)}
                                                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666' }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* GST Status */}
                                                        <div className="form-group">
                                                            <label className="input-label">GST Status</label>
                                                            <select
                                                                value={formData.gstData?.status || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        gstData: { ...prev.gstData, status: e.target.value }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="PENDING">PENDING</option>
                                                                <option value="VERIFIED">VERIFIED</option>
                                                                <option value="REJECTED">REJECTED</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ROW 7: PAN Section */}
                                                <div className="form-section">
                                                    <h3 className="section-title">PAN Details</h3>
                                                    <div className="form-group-row">
                                                        {/* PAN Number */}
                                                        <div className="form-group">
                                                            <label className="input-label">PAN Number</label>
                                                            <div style={{ position: 'relative' }}>
                                                                <input
                                                                    type="text"
                                                                    style={{ paddingRight: '40px' }}
                                                                    value={showGstPan ? (formData.panData?.pan || "") : maskId(formData.panData?.pan || "")}
                                                                    onChange={(e) =>
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            panData: { ...prev.panData, pan: e.target.value }
                                                                        }))
                                                                    }
                                                                />
                                                                <Icon
                                                                    icon={showGstPan ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                                                    onClick={() => setShowGstPan(!showGstPan)}
                                                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666' }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* PAN Type */}
                                                        <div className="form-group">
                                                            <label className="input-label">PAN Type</label>
                                                            <select
                                                                value={formData.panData?.type || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        panData: { ...prev.panData, type: e.target.value }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="">Select Type</option>
                                                                <option value="INDIVIDUAL">Individual</option>
                                                                <option value="COMPANY">Company</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="form-group-row">

                                                        {/* Name on Card */}
                                                        <div className="form-group">
                                                            <label className="input-label">Name on Card</label>
                                                            <input
                                                                type="text"
                                                                value={formData.panData?.nameOnCard || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        panData: { ...prev.panData, nameOnCard: e.target.value }
                                                                    }))
                                                                }
                                                            />
                                                        </div>

                                                        {/* PAN Status */}
                                                        <div className="form-group">
                                                            <label className="input-label">Status</label>
                                                            <select
                                                                value={formData.panData?.status || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        panData: { ...prev.panData, status: e.target.value }
                                                                    }))
                                                                }
                                                            >
                                                                <option value="PENDING">PENDING</option>
                                                                <option value="VERIFIED">VERIFIED</option>
                                                                <option value="REJECTED">REJECTED</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ROW 8: Documents */}
                                                <div className="form-group-row">
                                                    <label className="input-label"> Documents</label>
                                                    <div className="document-list">
                                                        {documents.map((doc, idx) => (
                                                            <div key={idx} className="document-row-single">
                                                                <button

                                                                    type="button"
                                                                    className="remove-doc-btn"
                                                                    onClick={() => removeDocumentRow(idx)}
                                                                >
                                                                    ✕
                                                                </button>
                                                                <select
                                                                    className="store-input"
                                                                    value={doc.documentType}
                                                                    onChange={(e) =>
                                                                        updateDocumentRow(idx, "documentType", e.target.value)
                                                                    }
                                                                >
                                                                    <option value="">Select Document Type</option>
                                                                    <option value="MASKED UDYOG AADHAR">MASKED UDYOG AADHAR</option>
                                                                    <option value="INCORPORATION CERTIFICATE">INCORPORATION CERTIFICATE</option>
                                                                    <option value="MSME REGISTRATION">MSME REGISTRATION</option>
                                                                </select>
                                                                {doc.documentType === "OTHERS" && (
                                                                    <input
                                                                        type="text"
                                                                        className="store-input"
                                                                        placeholder="Document Name"
                                                                        value={doc.documentName}
                                                                        onChange={(e) =>
                                                                            updateDocumentRow(idx, "documentName", e.target.value)
                                                                        }
                                                                    />
                                                                )}
                                                                {doc.files && doc.files.length > 0 && (
                                                                    <div className="uploaded-file-list">
                                                                        {doc.files.map((file, fIdx) => (
                                                                            <div key={fIdx} className="uploaded-file-item">
                                                                                <a
                                                                                    href={process.env.REACT_APP_API_URL + file.uri}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {file.fileName || "View File"}
                                                                                </a>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                <input
                                                                    type="file"
                                                                    multiple
                                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                                    className="store-input"
                                                                    onChange={(e) => handleDocumentFiles(idx, e.target.files)}
                                                                />
                                                            </div>
                                                        ))}

                                                        <button
                                                            type="button"
                                                            className="add-row-btn"
                                                            disabled={documents.length >= 10}
                                                            onClick={addDocumentRow}
                                                        >
                                                            + Add Document Row
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* BUTTONS */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <div className="form-actions">
                                                            <button type="submit" className="add-Product-button" onClick={handleUpdateFranchise}>Update Franchisor</button>
                                                            <button type="button" className="cancel-Product-button" onClick={() => setIsPopupMode(false)}>
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && franchises.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Franchise
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this franchise?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteFranchise}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>

                            {/* Premium View Franchise Modal */}
                            <Modal
                                open={isViewFranchise}
                                onClose={() => setIsViewFranchise(false)}
                                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(5px)', bgcolor: 'rgba(15, 23, 42, 0.2)', zIndex: 9999 }}
                            >
                                <Box sx={{
                                    width: '100%', maxWidth: 900, maxHeight: '90vh', bgcolor: '#ffffff',
                                    borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                                    overflow: 'hidden', display: 'flex', flexDirection: 'column',
                                    border: '1px solid #e2e8f0', outline: 'none'
                                }}>
                                    {/* Premium Header */}
                                    <Box sx={{
                                        px: 4, py: 3,
                                        background: 'linear-gradient(135deg, #3C0008 0%, #6d000e 100%)',
                                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                        borderBottom: '1px solid #3C0008', position: 'relative'
                                    }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{
                                                width: 52, height: 52, borderRadius: '14px', bgcolor: 'rgba(255,255,255,0.15)', color: '#fff',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                <Icon icon="mdi:office-building" fontSize={28} />
                                            </Box>
                                            <Box>
                                                <Typography sx={{ fontWeight: 800, fontSize: '20px', color: '#fff', lineHeight: 1.2, letterSpacing: '-0.5px' }}>
                                                    {viewFranchiseData?.franchiseName || 'FRANCHISE DETAILS'}
                                                </Typography>
                                                <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                                                    <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <Icon icon="mdi:email-outline" fontSize={14} /> {viewFranchiseData?.emailAddress || '---'}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <Icon icon="mdi:phone-outline" fontSize={14} /> {viewFranchiseData?.phoneNumber || '---'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Button
                                            onClick={() => setIsViewFranchise(false)}
                                            sx={{ minWidth: 40, width: 40, height: 40, borderRadius: '12px', color: '#fff', bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }}
                                        >
                                            <Icon icon="mdi:close" fontSize={24} />
                                        </Button>
                                    </Box>

                                    {/* Scrollable Content */}
                                    <Box sx={{
                                        p: 4, overflowY: 'auto', flex: 1, bgcolor: '#f8fafc',
                                        '&::-webkit-scrollbar': { width: '6px' },
                                        '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '10px' }
                                    }}>
                                        {viewFranchiseData ? (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                {/* Stats Cards */}
                                                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 3 }}>
                                                    {[
                                                        { label: 'ADMINISTRATOR', value: viewFranchiseData.franchiseAdmin?.[0]?.name || viewFranchiseData.users?.find(u => u.role === "FranchiseAdmin")?.name || 'N/A', icon: 'mdi:account-tie', color: '#3C0008', bg: '#f9f1f2' },
                                                        { label: 'HEADQUARTERS', value: `${viewFranchiseData.address || ''}, ${viewFranchiseData.state || ''}`.replace(/^, /, '') || 'Not Set', icon: 'mdi:map-marker', color: '#3C0008', bg: '#f9f1f2' },
                                                        { label: 'ENTITY STATUS', value: viewFranchiseData.isActive ? 'ACTIVE SERVICE' : 'SUSPENDED', icon: 'mdi:shield-check', color: '#3C0008', bg: '#f9f1f2' }
                                                    ].map((item, i) => (
                                                        <Paper key={i} elevation={0} sx={{ p: 2.5, borderRadius: '20px', border: '1px solid #e2e8f0', bgcolor: '#fff', display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                                            <Box sx={{ width: 48, height: 48, borderRadius: '16px', bgcolor: item.bg, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Icon icon={item.icon} fontSize={26} />
                                                            </Box>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</Typography>
                                                                <Typography sx={{ fontSize: '15px', fontWeight: 700, color: '#1e293b' }}>{item.value}</Typography>
                                                            </Box>
                                                        </Paper>
                                                    ))}
                                                </Box>

                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 3 }}>
                                                    {/* Compliance Section */}
                                                    <Paper elevation={0} sx={{ p: 3, borderRadius: '24px', border: '1px solid #e2e8f0', bgcolor: '#fff' }}>
                                                        <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#3C0008', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Box sx={{ width: 4, height: 16, bgcolor: '#3C0008', borderRadius: 1 }} /> TAXATION & COMPLIANCE
                                                        </Typography>
                                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                                                            <Box sx={{ p: 2.5, borderRadius: '16px', bgcolor: '#f9f1f2', border: '1px dashed #3C0008', position: 'relative' }}>
                                                                <Typography sx={{ fontSize: '11px', color: '#3C0008', fontWeight: 800, mb: 1 }}>GST STATUS</Typography>
                                                                <Typography sx={{ fontSize: '18px', fontWeight: 900, color: '#3C0008' }}>{viewFranchiseData.gstData?.status || 'PENDING'}</Typography>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <Typography sx={{ fontSize: '12px', color: '#166534', opacity: 0.8, fontFamily: 'monospace' }}>
                                                                        {showGstPan
                                                                            ? decryptData(viewFranchiseData.gstData?.gstNumber)
                                                                            : maskId(decryptData(viewFranchiseData.gstData?.gstNumber)) || 'NO GSTIN'}
                                                                    </Typography>
                                                                    <Icon
                                                                        icon={showGstPan ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                                                        onClick={() => setShowGstPan(!showGstPan)}
                                                                        style={{ cursor: 'pointer', fontSize: '16px', color: '#3C0008' }}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                            <Box sx={{ p: 2.5, borderRadius: '16px', bgcolor: '#f9f1f2', border: '1px dashed #3C0008', position: 'relative' }}>
                                                                <Typography sx={{ fontSize: '11px', color: '#3C0008', fontWeight: 800, mb: 1 }}>PAN PROFILE</Typography>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <Typography sx={{ fontSize: '18px', fontWeight: 900, color: '#3C0008', fontFamily: 'monospace' }}>
                                                                        {showGstPan
                                                                            ? decryptData(viewFranchiseData.panData?.pan)
                                                                            : maskId(decryptData(viewFranchiseData.panData?.pan)) || 'N/A'}
                                                                    </Typography>
                                                                    <Icon
                                                                        icon={showGstPan ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                                                        onClick={() => setShowGstPan(!showGstPan)}
                                                                        style={{ cursor: 'pointer', fontSize: '18px', color: '#3C0008' }}
                                                                    />
                                                                </Box>
                                                                <Typography sx={{ fontSize: '11px', color: '#1d4ed8', opacity: 0.8 }}>NAME: {viewFranchiseData.panData?.nameOnCard || 'N/A'}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </Paper>

                                                    {/* Brands Section */}
                                                    <Paper elevation={0} sx={{ p: 3, borderRadius: '24px', border: '1px solid #e2e8f0', bgcolor: '#fff' }}>
                                                        <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#3C0008', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Box sx={{ width: 4, height: 16, bgcolor: '#3C0008', borderRadius: 1 }} /> LICENSED BRANDS
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                            {viewFranchiseData.brandNames?.length > 0 ? viewFranchiseData.brandNames.map((brand, idx) => (
                                                                <Box key={idx} sx={{ px: 2, py: 1, borderRadius: '10px', bgcolor: '#f9f1f2', color: '#3C0008', fontWeight: 700, fontSize: '12px', border: '1px solid #3C0008' }}>
                                                                    {brand}
                                                                </Box>
                                                            )) : <Typography sx={{ color: '#94a3b8', fontSize: '13px', fontStyle: 'italic' }}>No registered brands</Typography>}
                                                        </Box>
                                                    </Paper>
                                                </Box>

                                                {/* Document Gallery */}
                                                <Box>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#3C0008', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 4, height: 16, bgcolor: '#3C0008', borderRadius: 1 }} /> DOCUMENT ARCHIVE
                                                    </Typography>
                                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                                                        {viewFranchiseData.documents?.length > 0 ? viewFranchiseData.documents.map((doc, idx) => (
                                                            <Box key={idx} sx={{
                                                                p: 2, borderRadius: '18px', border: '1px solid #e2e8f0', bgcolor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                '&:hover': { border: '1px solid #3C0008', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }, transition: 'all 0.3s'
                                                            }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                    <Box sx={{ width: 44, height: 44, borderRadius: '12px', bgcolor: '#f9f1f2', color: '#3C0008', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Icon icon="mdi:file-certificate" fontSize={24} />
                                                                    </Box>
                                                                    <Box>
                                                                        <Typography sx={{ fontWeight: 800, fontSize: '13px', color: '#1e293b' }}>{doc.documentType || 'Official Record'}</Typography>
                                                                        <Typography sx={{ fontSize: '11px', color: '#64748b' }}>Cloud Storage Verified</Typography>
                                                                    </Box>
                                                                </Box>
                                                                <Button
                                                                    variant="text"
                                                                    size="small"
                                                                    sx={{ fontWeight: 800, color: '#3C0008', '&:hover': { bgcolor: '#f9f1f2' } }}
                                                                    onClick={() => window.open(process.env.REACT_APP_API_URL + doc.files?.[0]?.uri, '_blank')}
                                                                >
                                                                    VIEW
                                                                </Button>
                                                            </Box>
                                                        )) : (
                                                            <Box sx={{ gridColumn: 'span 2', p: 5, borderRadius: '20px', border: '2px dashed #e2e8f0', textAlign: 'center', bgcolor: '#f1f5f9' }}>
                                                                <Icon icon="mdi:folder-open-outline" fontSize={48} style={{ color: '#cbd5e1', marginBottom: '8px' }} />
                                                                <Typography sx={{ color: '#94a3b8', fontSize: '14px', fontWeight: 600 }}>No documents found in archive</Typography>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box sx={{ p: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                                                <CircularProgress size={64} thickness={4} sx={{ color: '#3C0008' }} />
                                                <Typography sx={{ fontWeight: 800, color: '#64748b', fontSize: '18px', letterSpacing: '1px' }}>
                                                    SECURE SYNCHRONIZATION...
                                                </Typography>
                                                <Typography sx={{ color: '#94a3b8', fontSize: '13px' }}>Fetching encrypted franchise intelligence</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )
                    }
                </main >
                <Footer />
            </div >
        </div >
    );
};

export default FranchisePage;